import { ref, watch } from 'vue'

const isDark = ref(localStorage.getItem('theme') === 'dark')

let _isInitialLoad = true
let _originX = '50%'
let _originY = '50%'

export function setThemeTransitionOrigin(x: string, y: string) {
  _originX = x
  _originY = y
}

function applyTheme(dark: boolean) {
  const apply = () => {
    document.documentElement.classList.toggle('dark', dark)
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }

  if (_isInitialLoad || !('startViewTransition' in document)) {
    apply()
    _isInitialLoad = false
    return
  }

  document.documentElement.style.setProperty('--vt-x', _originX)
  document.documentElement.style.setProperty('--vt-y', _originY)
  ;(document as Document & { startViewTransition: (cb: () => void) => void }).startViewTransition(apply)
}

applyTheme(isDark.value)

watch(isDark, (val) => applyTheme(val))

export function useDarkMode() {
  function toggleDarkMode() {
    isDark.value = !isDark.value
  }

  return { isDark, toggleDarkMode }
}
